import { ApiError } from '@/api/ApiError'
import type { QueryClient } from '@tanstack/react-query'

export const ORGANIZATION_NAME_MAX_LENGTH = 60

export const ORGANIZATION_NAME_PATTERN = /^[a-zA-Z0-9-_ ]+$/

const ERROR_KEY_PREFIX = 'orgDetails.rename.error'

const ERROR_MESSAGE_KEYS_BY_STATUS: Record<number, string> = {
  400: `${ERROR_KEY_PREFIX}.invalid`,
  401: `${ERROR_KEY_PREFIX}.unauthorized`,
  404: `${ERROR_KEY_PREFIX}.notFound`,
}

export function renameErrorMessageKey(error: unknown): string {
  if (error instanceof ApiError) {
    return (
      ERROR_MESSAGE_KEYS_BY_STATUS[error.status] ??
      `${ERROR_KEY_PREFIX}.generic`
    )
  }
  return `${ERROR_KEY_PREFIX}.generic`
}

export function invalidateRenamedOrganization(
  queryClient: QueryClient,
  orgId: string,
) {
  queryClient.invalidateQueries({ queryKey: ['api', 'v2', 'orgs', orgId] })
  queryClient.invalidateQueries({ queryKey: ['api', 'v3', 'search', 'orgs'] })
}
